module.exports = __webpack_public_path__ + "static/media/4 Seats 5 Sides (connected).0ab52767.png";